export const routes = {
  INDEX: '/',
  ABOUT: {
    INDEX: '/about'
  },
  PACKAGES: {
    INDEX: '/trip-packs',
    TRIP_PACK_RESULTS: '/trip-packs-result',
  },
  STAYS: {
    INDEX: '/stays',
    STAYS_RESULTS: '/stays-result',
  },
  TICKETS: {
    INDEX: '/tickets',
    AIRPLANE: '/tickets-airplane'
  },
  WISHLIST: {
    INDEX: '/wishlist',
  },
  EXPERIENCES: {
    INDEX: '/experiences',
  },
  BOOKING: {
    INDEX: '/booking',
    HOW_TO_PAY: '/booking/how-to-pay',
    PAYMENT_METHOD: '/booking/payment-method',
    DETAILS: '/booking/details',
    PAYMENT_FAILED: '/booking/payment-failed',
    PAYMENT_SUCCESSFUL: '/booking/payment-successful'
  },
  PROFILE: {
    INDEX: '/profile',
    TRIPS: '/trips',
    TRIP_ITINERARY: '/trip-itinerary/:id'
  }
};
